<template>
  <div>
    <div class="text-xl font-bold text-text leading-tight mb-11">{{ $t('title') }}</div>
    <template v-if="!!activeTickets.length">
      <div class="bg-line px-6 py-4 -mx-6 rounded text-sm text-text-ternary">
        {{ $t('opened') }}
      </div>
      <div class="divide-y divide-border mb-14">
        <TicketSystemListItem v-for="ticket in activeTickets" :key="`ticket-${ticket.id}`" :ticket="ticket"/>
      </div>
    </template>
    <template v-if="!!closedTickets.length">
      <div class="bg-line px-6 py-4 -mx-6 rounded text-sm text-text-ternary">
        {{ $t('closed') }}
      </div>
      <div class="divide-y divide-border mb-14">
        <TicketSystemListItem v-for="ticket in closedTickets" :key="`ticket-${ticket.id}`" :ticket="ticket"/>
      </div>
    </template>
  </div>
</template>

<script>
import BaseBadge from "@/components/UI/BaseBadge";
import TicketSystemListItem from "@/components/cabinet/Tickets/TicketsSystem/TicketSystemList/TicketsSystemListItem";

export default {
  name: "TicketsSystemList",
  components: {TicketSystemListItem, BaseBadge},
  props: {
    activeTickets: {
      type: Array,
      default: () => []
    },
    closedTickets: {
      type: Array,
      default: () => []
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'List of tickets',
        opened: 'In process',
        closed: 'Answered',
      },
      ru: {
        title: 'Обращения',
        opened: 'Открытые',
        closed: 'Закрытые',
      }
    }
  }
}
</script>

<style scoped>
.ticket-item-grid {
  display: grid;
  grid-template-columns: 90px 210px auto auto;
  grid-column-gap: 10px;
  align-items: center;
}
</style>